import React from 'react';
import Button from './Button';
// import { useLocation } from 'react-router-dom'; // Não usado
import { paginationClasses } from '../../utils/cssFixers';

export interface PaginationProps {
  currentPage: number;
  totalPages?: number;
  totalItems?: number;
  onPageChange: (page: number) => void;
  preserveParams?: boolean; // Optional prop to preserve URL parameters
  pageSize?: number; // Optional page size
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages: propsTotalPages,
  totalItems,
  onPageChange,
  preserveParams = true, // Default to preserving parameters
  pageSize
}) => {
  // const location = useLocation(); // Não está sendo usado

  // Calculate totalPages from totalItems and pageSize if not provided
  const totalPages = propsTotalPages || (totalItems && pageSize ? Math.ceil(totalItems / pageSize) : 1);

  // Generate array of page numbers to show
  const getPageNumbers = () => {
    // If no pages, return empty list
    if (totalPages <= 0) return [];

    const pageNumbers: number[] = [];

    // Always show first page
    pageNumbers.push(1);

    // Current page and pages around it
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
      pageNumbers.push(i);
    }

    // Always show last page if there are multiple pages
    if (totalPages > 1) {
      pageNumbers.push(totalPages);
    }

    // Add ellipsis indicators
    const result: (number | string)[] = [];
    let previous = 0;

    for (const page of pageNumbers) {
      if (page - previous > 1) {
        result.push('...');
      }
      result.push(page);
      previous = page;
    }

    return result;
  };

  // Calculate the range of items displayed on the current page
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getItemRange = () => {
    if (!pageSize || !totalItems) return null;

    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, totalItems);

    return `${start}-${end} of ${totalItems}`;
  };

  if (totalPages <= 1 && (!totalItems || totalItems <= (pageSize || 10))) {
    return null;
  }

  return (
    <div className={`${paginationClasses.container} pagination-container`}>
      {/* Pagination controls with centered design */}
      <div className={`${paginationClasses.controls} pagination-controls`}>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="pagination-prev-button"
        >
          <i className="fas fa-chevron-left mr-1"></i>
          Previous
        </Button>

        <div className={`${paginationClasses.pageNumbers} pagination-page-numbers`}>
          {getPageNumbers().map((page, index) => (
            page === '...' ? (
              <span key={`ellipsis-${index}`} className={`${paginationClasses.ellipsis} pagination-ellipsis`}>...</span>
            ) : (
              <button
                key={`page-${page}`}
                onClick={() => onPageChange(page as number)}
                className={`${paginationClasses.pageButton(currentPage === page)} pagination-button ${
                  currentPage === page ? 'pagination-button-active' : 'pagination-button-inactive'
                }`}
              >
                {page}
              </button>
            )
          ))}
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="pagination-next-button"
        >
          Next
          <i className="fas fa-chevron-right ml-1"></i>
        </Button>
      </div>
    </div>
  );
};

export default Pagination;